import { render, staticRenderFns } from "./Packing.vue?vue&type=template&id=617dc6ee&"
import script from "./Packing.vue?vue&type=script&lang=ts&"
export * from "./Packing.vue?vue&type=script&lang=ts&"
import style0 from "./Packing.vue?vue&type=style&index=0&id=617dc6ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports